import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Automation } from './automation'

export class AutomationsRepository extends BaseRepository<Automation> {
    constructor(
        automationGroupsId,
        config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.automationApiUrl + '/' + 'automations' + '/' + automationGroupsId + '/acts', token, cache)
    }
}
